import { Component } from '@angular/core';

@Component({
  selector: 'portal-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent { }
